export default __webpack_public_path__ + "static/media/msc.7bc3fecd.png";